import { createSelector } from 'reselect'

import { isObject } from 'shared/helpers/obj_helpers'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES

export const getCurrentUserId = state => {
  return state.current_user && state.current_user.id
    ? state.current_user.id
    : ''
}
export const getCampaigns = state => state.campaign

export const getCampaignFromProps = (state, { campaignId }) => {
  return state.campaign[campaignId]
}
const getCampaignFromLastCreationId = state =>
  state.campaign[state.campaign.last_creation_id]

export const getLastCreatedCampaignSelector = createSelector(
  getCampaignFromLastCreationId,
  campaign => campaign
)

export const getCampaignSelector = createSelector(
  getCampaignFromProps,
  campaign => campaign
)

export const getNewCampaignSelector = createSelector(
  getCampaigns,
  campaigns => {
    return campaigns[NEW_CAMPAIGN_ID]
  }
)

function isValidCampaign(campaign) {
  if (!isObject(campaign)) {
    return false
  }

  if (campaign.deleted || campaign.id === NEW_CAMPAIGN_ID) {
    return false
  }

  return true
}

export function getCrowdfundingEntryBanner(state) {
  return state.flags && state.flags.allow_crowdfunding_entry_banner
}

export const allCampaignsSelector = createSelector(getCampaigns, campaigns => {
  let allCampaigns = Object.values(campaigns).filter(isValidCampaign)

  // campaign2 is before campaign1 so that it will be sorted in descending order
  allCampaigns.sort(
    (campaign1, campaign2) =>
      new Date(campaign2.start_date).valueOf() -
      new Date(campaign1.start_date).valueOf()
  )
  return allCampaigns
})

export const isGNSelector = createSelector(getCampaignSelector, campaign => {
  const hasCrowdfinding = Boolean(
    campaign && campaign.campaign_type === CROWD_FUNDING
  )
  const hasCharity = Boolean(campaign && campaign.charity)

  if (hasCharity) {
    return false
  }
  return hasCrowdfinding
})

export const isGNCSelector = createSelector(getCampaignSelector, campaign => {
  const hasCrowdfinding = Boolean(
    campaign && campaign.campaign_type === CROWD_FUNDING
  )
  const hasCharity = Boolean(campaign && campaign.charity)

  if (!hasCharity) {
    return false
  }
  return hasCrowdfinding
})
